<template>
  <div>
    <b-modal
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @hidden="closeModal"
      ok-title="Enviar"
      id="modal-custom-email"
      modal
      :title="
        step === 1
          ? $ml.get('emailContent')
          : step === 2
          ? $ml.get('recipients')
          : $ml.get('summary')
      "
    >
      <div class="row">
        <form class="col-24" v-if="step === 1">
          <div class="col input-group mb-2">
            <b-form-datepicker
              :disabled="emailStatus === 'approved' || emailStatus === 'sent'"
              class="datepicker m-0 p-0"
              label-help=""
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              :locale="$ml.get('ln')"
              today-button
              reset-button
              close-button
              :label-today-button="$ml.get('today')"
              :label-reset-button="$ml.get('reset')"
              :label-close-button="$ml.get('exit')"
              :min="minDateInitialCampaign"
              v-model="dateSendEmail"
              :placeholder="$ml.get('scheduleDate')"
              @input="saveLocalStorage"
            >
            </b-form-datepicker>
          </div>
          <div style="position: relative">
            <div class="email-fill">
              <svg width="24" height="24">
                <image
                  xlink:href="../../../assets/icons/email-fill.svg"
                  width="24"
                  height="24"
                />
              </svg>
            </div>
            <input
              :disabled="emailStatus === 'approved' || emailStatus === 'sent'"
              type="text"
              class="form-control mb-2"
              style="padding: 0px 38px"
              :placeholder="$ml.get('placeholderMessageTopic')"
              v-model="topic"
              @input="saveLocalStorage"
            />
          </div>
          <div class="col">
            <svg
              v-show="!htmlText"
              @click="viewHtml()"
              width="24"
              height="24"
              class="ico-view-report"
            >
              <image
                xlink:href="../../../assets/icons/eye.svg"
                width="24"
                height="24"
              />
            </svg>
            <svg
              v-show="htmlText"
              @click="htmlText = ''"
              width="24"
              height="24"
              class="ico-view-report"
            >
              <image
                xlink:href="../../../assets/icons/eye-slash.svg"
                width="24"
                height="24"
              />
            </svg>
            <textarea
              :disabled="emailStatus === 'approved' || emailStatus === 'sent'"
              v-show="!htmlText"
              class="form-control-textarea w-110 text-are-mark"
              v-model="description"
              ref="textarea"
              :placeholder="$ml.get('placeholderMessageEmail')"
              @input="saveLocalStorage"
              rows="14"
            >
            </textarea>
            <div
              v-show="htmlText"
              class="form-control w-100 h-100"
              v-html="htmlText"
            ></div>
          </div>
        </form>

        <div class="col" v-if="step === 2">
          <!--Programas Privados-->
          <div class="d-flex justify-content-between" style="gap: 10px">
            <div
              class="col card card-visitors"
              v-if="emailStatus != 'approved' && emailStatus != 'sent'"
            >
              <div class="card-header card-chart-mini">
                <div class="d-flex flex-row align-items-center flex-gap">
                  <svg width="24" height="24">
                    <image
                      xlink:href="../../../assets/icons/key-fill-purple.svg"
                      width="24"
                      height="24"
                    />
                  </svg>
                  <span v-text="$ml.get('cardPrivateProgram')"
                    >Programas privados</span
                  >
                </div>
              </div>
              <div class="card-body card-lateral">
                <div class="col p-2">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$ml.get('placeholderFilterProgram')"
                    v-model="searchProgram"
                  />
                </div>
                <div v-if="!listAllPrograms.length" class="no-program">
                  <span v-text="$ml.get('noProgramAvailable')"
                    >Nenhum programa disponível</span
                  >
                </div>
                <div
                  v-for="program in listAllPrograms"
                  :key="program._id"
                  class="c-private-programs"
                  :style="{
                    backgroundColor: program.selected
                      ? '#7b787b1a'
                      : 'transparent',
                  }"
                >
                  <span class="program-title">{{ program.name }}</span>
                  <div class="custom-control custom-checkbox ml-4">
                    <input
                      type="checkbox"
                      class="custom-control-input pointer"
                      v-model="program.selected"
                    />
                    <label class="custom-control-label"></label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Hackers -->
            <div v-if="!modeEditEmail" class="col">
              <div class="col">
                <div class="card card-visitors card-hacker">
                  <div class="card-header card-chart-mini">
                    <div class="d-flex flex-row align-items-center flex-gap">
                      <svg width="24" height="24">
                        <image
                          xlink:href="../../../assets/icons/hacker-fill.svg"
                          width="24"
                          height="24"
                        />
                      </svg>
                      <span v-text="$ml.get('titleCardHacker')"
                        >Especialistas</span
                      >
                    </div>
                  </div>
                  <div class="card-body">
                    <div
                      class="d-flex justify-content-center py-2 b-top"
                      v-if="loading"
                    >
                      <div class="c-loader"></div>
                    </div>

                    <div class="col p-2" v-if="!loading">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$ml.get('placeholderFilterHacker')"
                        v-model="searchHacker"
                      />
                    </div>
                    <div
                      v-if="!listAllHackers.length && !loading"
                      class="no-program"
                    >
                      <span v-text="$ml.get('hackerListEmpety')"
                        >Nenhum especialista disponível</span
                      >
                    </div>
                    <div v-if="listAllHackers.length && !loading">
                      <div
                        v-for="hacker in listAllHackers"
                        :key="hacker.hackerId"
                        class="c-private-programs"
                        :style="{
                          backgroundColor: hacker.selected
                            ? '#7b787b1a'
                            : 'transparent',
                        }"
                      >
                        <span class="user-title">{{ hacker.username }}</span>
                        <div class="custom-control custom-checkbox ml-4">
                          <input
                            type="checkbox"
                            class="custom-control-input pointer"
                            v-model="hacker.selected"
                          />
                          <label class="custom-control-label"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="totalPages > 10" class="mt-2">
                  <b-pagination
                    v-model="pageActive"
                    :total-rows="totalPages"
                    :per-page="10"
                    :prev-text="$ml.get('previous')"
                    :next-text="$ml.get('next')"
                    align="right"
                  >
                  </b-pagination>
                </div>
              </div>
            </div>

            <!-- Especialistas modo edição -->
            <div v-else class="col">
              <div class="col">
                <div class="card card-visitors card-hacker mb-1">
                  <div class="card-header card-chart-mini">
                    <div class="d-flex flex-row align-items-center flex-gap">
                      <svg width="24" height="24">
                        <image
                          xlink:href="../../../assets/icons/hacker-fill.svg"
                          width="24"
                          height="24"
                        />
                      </svg>
                      <span v-text="$ml.get('titleCardHacker')"
                        >Especialistas</span
                      >
                    </div>
                  </div>
                  <div class="card-body">
                    <div
                      class="d-flex justify-content-center py-2 b-top"
                      v-if="loading"
                    >
                      <div class="c-loader"></div>
                    </div>

                    <div class="col p-2" v-show="!loading">
                      <input
                        :disabled="
                          emailStatus === 'approved' || emailStatus === 'sent'
                        "
                        type="text"
                        class="form-control"
                        :placeholder="$ml.get('placeholderFilterHacker')"
                        v-model="searchHacker"
                      />
                    </div>
                    <div
                      v-if="!listOfHackersForEditing.length && !loading"
                      class="no-program"
                    >
                      <span v-text="$ml.get('hackerListEmpety')"
                        >Nenhum especialista disponível</span
                      >
                    </div>
                    <div v-if="listOfHackersForEditing.length && !loading">
                      <div
                        v-for="hacker in listOfHackersForEditing"
                        :key="hacker.hackerId"
                        class="c-private-programs"
                        :style="{
                          backgroundColor: hacker.selected
                            ? '#7b787b1a'
                            : 'transparent',
                        }"
                      >
                        <span class="user-title">{{ hacker.username }}</span>
                        <div
                          class="custom-control custom-checkbox ml-4"
                          v-if="
                            emailStatus != 'approved' && emailStatus != 'sent'
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input pointer"
                            v-model="hacker.selected"
                          />
                          <label class="custom-control-label"></label>
                        </div>
                        <div v-else>
                          <svg width="18" height="18">
                            <image
                              xlink:href="../../../assets/icons/check-fill-email.svg"
                              width="18"
                              height="18"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="totalPages > 10 && !loading" class="mt-2">
                  <b-pagination
                    v-model="pageActive"
                    :total-rows="totalPages"
                    :per-page="10"
                    :prev-text="$ml.get('previous')"
                    :next-text="$ml.get('next')"
                    align="right"
                  >
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="step === 3" class="col-24">
          <div class="alert alert-warning">
            {{ $ml.get("yourEmailWillBeAnalyzed") }}
            <strong>{{ $utils.formatDataShort(dateSendEmail) }}</strong>
          </div>
          <div class="box-details col">
            <div
              class="p-2 d-flex justify-content-between align-items-center box-header"
            >
              <span style="font-weight: 400"
                ><strong>{{ $ml.get("emailTopic") }}: </strong
                >{{ this.topic }}</span
              >
              <div class="pointer" @click="showDescription = !showDescription">
                <div v-if="showDescription">
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-up.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-down.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              v-show="showDescription"
              class="p-2"
              style="border-top: 1px solid #cccc"
            >
              <p v-html="$utils.convertMarkedOld(this.description)"></p>
            </div>
          </div>
          <div class="box-details">
            <div
              class="p-2 d-flex justify-content-between align-items-center box-header"
            >
              <span
                ><strong v-text="$ml.get('titleCardSelectedProgram')"
                  >Programas selecionados</strong
                ></span
              >
              <div class="pointer" @click="showPrograms = !showPrograms">
                <div v-if="showPrograms">
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-up.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-down.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div v-show="showPrograms">
              <div
                v-for="program in listProgramSelected"
                :key="program._id"
                class="box-program px-2"
              >
                <span style="font-weight: 400">{{ program.name }}</span>
                <div>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/check-fill-email.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="box-details">
            <div
              class="p-2 d-flex justify-content-between align-items-center box-header"
            >
              <div v-if="!modeEditEmail">
                <span v-if="totalHackers < 10"
                  ><strong
                    >{{
                      $ml.get("hackersSelected") + ": " + "0" + totalHackers
                    }}
                  </strong></span
                >
                <span v-else
                  ><strong
                    >{{
                      $ml.get("hackersSelected") +
                      ": " +
                      listProgramSelected.length
                    }}
                  </strong></span
                >
              </div>

              <div v-else>
                <span v-if="totalHackersModeEditing < 10"
                  ><strong
                    >{{
                      $ml.get("hackersSelected") +
                      ": " +
                      "0" +
                      totalHackersModeEditing
                    }}
                  </strong></span
                >
                <span v-else
                  ><strong
                    >{{
                      $ml.get("hackersSelected") +
                      ": " +
                      listProgramSelected.length
                    }}
                  </strong></span
                >
              </div>
              <div class="pointer" @click="showHackers = !showHackers">
                <div v-if="showHackers">
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-up.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/expand-down.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div v-show="showHackers && !modeEditEmail">
              <div
                v-for="hacker in listHackersSelected"
                :key="hacker.hackerId"
                class="box-program px-2"
              >
                <span style="font-weight: 400">{{ hacker.username }}</span>
                <div>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/check-fill-email.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div v-show="showHackers && modeEditEmail">
              <div
                v-for="hacker in listOfHackersForEditing"
                :key="hacker.hackerId"
                v-show="hacker.selected"
                class="box-program px-2"
              >
                <span style="font-weight: 400" v-if="hacker.selected">{{
                  hacker.username
                }}</span>
                <div>
                  <svg width="18" height="18">
                    <image
                      xlink:href="../../../assets/icons/check-fill-email.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div v-if="totalPages > 10 && showHackers" class="mt-2">
            <b-pagination
              v-model="pageActive"
              :total-rows="totalPages"
              :per-page="10"
              :prev-text="$ml.get('previous')"
              :next-text="$ml.get('next')"
              align="right"
            >
            </b-pagination>
          </div>
        </div>
        <div class="col-24 setep d-flex align-items-center">
          <div class="mr-5 btn-step-action" @click="backStep">
            <svg width="18" height="18">
              <image
                xlink:href="../../../assets/icons/back-fill.svg"
                width="18"
                height="18"
              />
            </svg>
          </div>
          <div
            class="step-option"
            :style="{ background: step === 1 ? '#730ba9' : '' }"
          ></div>
          <div
            class="step-option"
            :style="{ background: step === 2 ? '#730ba9' : '' }"
          ></div>
          <div
            class="step-option"
            :style="{ background: step === 3 ? '#730ba9' : '' }"
          ></div>
          <div class="ml-5 btn-step-action" @click="nextStep">
            <svg width="18" height="18">
              <image
                xlink:href="../../../assets/icons/next-fill.svg"
                width="18"
                height="18"
              />
            </svg>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          v-if="emailStatus === 'approved' || emailStatus === 'sent'"
          class="float-right btn-outline-extra"
          size="sm"
          variant="primary"
          @click="closeModal(), cancel()"
        >
          {{ $ml.get("toClose") }}
        </b-button>

        <b-button
          v-else
          style="background: #730ba9; min-width: 90px"
          size="sm"
          :disabled="
            !topic ||
            !description ||
            (!listAllHackers.length && !listOfHackersForEditing.length) ||
            !listProgramSelected.length ||
            !dateSendEmail ||
            step != 3
          "
          @click="modeEditEmail ? updatedEmail(ok) : sendEmail(ok)"
        >
          <span>{{
            modeEditEmail ? $ml.get("save") : $ml.get("sendForAnalysis")
          }}</span>
        </b-button>
      </template>
    </b-modal>

    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-24 col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('titleSendEmail')"></h1>
            <h1 class="title">
              <span class="pb-2" v-text="$ml.get('subTitlePageSendEmail')">
                Envie e-mails personalizados rapidamente para os programas e
                especialistas selecionados!</span
              >
            </h1>
            <div
              class="col d-flex justify-content-between align-items-center mt-4"
            >
              <div class="col-14 d-flex justify-content-between">
                <div class="input-group mr-2">
                  <input
                    class="form-control filterInput"
                    v-model="searchEmailList"
                    :placeholder="$ml.get('searchEmail')"
                    aria-label="Search"
                    style="border-right: none; outline: none !important"
                    @input="waitAPI"
                  />
                  <div class="input-group-append">
                    <div
                      class="input-group-text"
                      style="background-color: #fff"
                    >
                      <svg width="20" height="20" class="mt-1">
                        <image
                          xlink:href="../../../assets/icons/search_s.svg"
                          width="18"
                          height="18"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="col-12 pr-1 input-group">
                  <multiselect
                    v-model="listFilterSelected"
                    @input="getListEmail"
                    :options="listFilter"
                    :searchable="false"
                    label="name"
                    :close-on-select="true"
                    :show-labels="false"
                    :allow-empty="false"
                    :preselect-first="true"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
              </div>
              <button
                v-b-modal.modal-custom-email
                class="btn"
                @click="changePrograms(), openModal()"
                v-text="$ml.get('createEmail')"
              >
                Criar e-mail
              </button>
            </div>
          </div>
          <div class="card card-visitors mt-3">
            <div class="card-header card-chart-mini">
              <div class="d-flex flex-row align-items-center flex-gap">
                <span v-text="$ml.get('controlEmail')"
                  >Gerenciador de e-mails</span
                >
              </div>
            </div>
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between"
                style="padding: 10px"
              >
                <div class="col-8">
                  <span
                    class="header-status-email"
                    v-text="$ml.get('emailTopic')"
                    >Assunto</span
                  >
                </div>
                <div class="col-7">
                  <span class="header-status-email" v-text="$ml.get('status')"
                    >Status</span
                  >
                </div>
                <div class="col-7">
                  <span
                    class="header-status-email"
                    v-text="$ml.get('dateSendEmail')"
                    >Data Programada</span
                  >
                </div>
                <div class="col-2"></div>
              </div>
              <div
                class="d-flex justify-content-center py-2 b-top"
                v-if="loadingListEmail && !listEmail.length"
              >
                <div class="c-loader"></div>
              </div>
              <div
                v-if="!listEmail.length && !loadingListEmail"
                class="no-program b-top"
              >
                <span v-text="$ml.get('noEmailsAvailable')"
                  >Nenhum email disponível</span
                >
              </div>
              <div v-for="email in listEmail" :key="email._id">
                <div class="c-private-programs">
                  <span class="email-status-text col-8">{{ email.topic }}</span>
                  <div class="email-status col-7">
                    <span
                      v-if="email.status === 'sent'"
                      class="badge badge-success"
                      >{{ $ml.get("sentEmail") }}</span
                    >
                    <span
                      v-else
                      :class="[
                        'badge',
                        email.status === 'approved'
                          ? 'badge-success'
                          : email.status === 'pending'
                          ? 'badge-warning'
                          : email.status === 'sent'
                          ? 'badge-success'
                          : 'badge-danger',
                      ]"
                      >{{ $ml.get(email.status) }}</span
                    >
                  </div>
                  <div class="col-7">
                    {{ $utils.formatDataShort(email.dateToSend) }}
                  </div>
                  <div
                    class="col-2 d-flex justify-content-end"
                    style="gap: 10px"
                  >
                    <div
                      v-if="email.status === 'rejected'"
                      @click="email.show_message = !email.show_message"
                    >
                      <VueCustomTooltip
                        v-if="!email.show_message"
                        :label="$ml.get('tooltipViewRejectedMessage')"
                      >
                        <svg width="18" height="18" class="pointer">
                          <image
                            xlink:href="../../../assets/icons/visibility-fill.svg"
                            width="18"
                            height="18"
                          />
                        </svg>
                      </VueCustomTooltip>
                      <VueCustomTooltip
                        :label="$ml.get('tooltipHiddenRejectedMessage')"
                        v-else
                      >
                        <svg width="18" height="18" class="pointer">
                          <image
                            xlink:href="../../../assets/icons/visibility-fill-off.svg"
                            width="18"
                            height="18"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div
                    v-if="email.status != 'sent' && email.status != 'approved'"
                      @click="changePrograms(email._id), (modeEditEmail = true)"
                      v-b-modal.modal-custom-email
                    >
                      <VueCustomTooltip :label="$ml.get('tooltipEditEmail')">
                        <svg width="16" height="16" class="pointer">
                          <image
                            xlink:href="../../../assets/icons/edit.png"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div
                      v-else
                      @click="changePrograms(email._id), (modeEditEmail = true)"
                      v-b-modal.modal-custom-email
                    >
                      <VueCustomTooltip :label="$ml.get('viewEmail')">
                        <svg width="18" height="18" class="pointer">
                          <image
                            xlink:href="../../../assets/icons/visibility-fill.svg"
                            width="18"
                            height="18"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div @click="deleteEmail(email._id)">
                      <VueCustomTooltip :label="$ml.get('tooltipDeleteEmail')">
                        <svg width="16" height="16" class="pointer">
                          <image
                            xlink:href="../../../assets/icons/trash-alt.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                  </div>
                </div>
                <div
                  class="alert alert-warning mb-0"
                  v-if="email.status === 'rejected' && email.show_message"
                >
                  <span>{{ email.justification }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2" v-show="totalPagesEmail > 10 && listEmail.length">
            <b-pagination
              v-model="pageActiveEmail"
              :total-rows="totalPagesEmail"
              :per-page="10"
              :prev-text="$ml.get('previous')"
              :next-text="$ml.get('next')"
              align="right"
            >
            </b-pagination>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Swal from "sweetalert2";
import {
  default as ProgramService,
  default as programService,
} from "../../../services/program.service";
export default {
  data() {
    return {
      loading: true,
      loadingListEmail: false,

      topic: "",
      description: ``,
      htmlText: "",
      dateSendEmail: null,

      searchProgram: "",
      searchHacker: "",
      searchEmailList: "",

      step: 1,

      showDescription: false,
      showPrograms: false,
      showHackers: false,

      dataSentEmail: [],
      idEmail: "",

      emailStatus: "",

      listProgram: [],
      listHackers: [],
      listEmail: [],

      pageActive: 1,
      pageSize: 10,

      pageActiveEmail: 1,
      pageSizeEmail: 10,
      totalPagesEmail: 0,

      modeEditEmail: false,

      listAllHackersModeEditing: [],
      oldListHackers: [],

      listFilterSelected: [],
      listFilter: [
        { name: this.$ml.get("all"), id: "" },
        { name: this.$ml.get("pending"), id: "pending" },
        { name: this.$ml.get("rejected"), id: "rejected" },
        { name: this.$ml.get("approved"), id: "approved" },
        { name: this.$ml.get("sentEmail"), id: "sent" },
      ],
    };
  },

  mounted() {
    this.changePrograms();
    this.getListEmail();
  },

  watch: {
    listProgram: {
      handler() {
        if (this.listProgramSelected.length) {
          this.getHackers();
        }

        if (!this.modeEditEmail) {
          localStorage.setItem("listProgram", JSON.stringify(this.listProgram));
        }
      },
      deep: true,
    },

    listHackers: {
      handler() {
        if (!this.modeEditEmail && this.listHackers.length) {
          localStorage.setItem("listHackers", JSON.stringify(this.listHackers));
        }
      },
      deep: true,
    },

    pageActiveEmail() {
      this.getListEmail();
    },
  },

  computed: {
    totalPages() {
      return this.modeEditEmail
        ? this.listAllHackersModeEditing.length
        : this.listHackers.length;
    },

    minDateInitialCampaign() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYY-MM-DD");
      return today;
    },

    listProgramSelected() {
      return this.listProgram.filter((program) => program.selected === true);
    },

    listAllPrograms() {
      if (this.searchProgram) {
        return this.listProgram.filter((program) =>
          program.name.toLowerCase().includes(this.searchProgram.toLowerCase()),
        );
      }
      return this.listProgram;
    },

    totalHackers() {
      return this.listHackers.filter((program) => program.selected === true)
        .length;
    },

    listHackersSelected() {
      let filteredList = this.listHackers ?? [];

      const start = (this.pageActive - 1) * this.pageSize;

      let listFiltered = filteredList.slice(start, start + this.pageSize);
      let hackerIds = this.listAllHackersModeEditing.map((h) => h.hackerId);
      listFiltered = listFiltered.filter(
        (h) => !hackerIds.includes(h.hackerId),
      );
      return listFiltered.filter((hacker) => hacker.selected);
    },

    listAllHackers() {
      let filteredList = this.listHackers ?? [];

      if (this.searchHacker) {
        filteredList = filteredList.filter((hacker) =>
          hacker.username
            .toLowerCase()
            .includes(this.searchHacker.toLowerCase()),
        );
        return filteredList;
      }

      // Paginação
      const start = (this.pageActive - 1) * this.pageSize;

      let listFiltered = filteredList.slice(start, start + this.pageSize);
      let hackerIds = this.listAllHackersModeEditing.map((h) => h.hackerId);
      listFiltered = listFiltered.filter(
        (h) => !hackerIds.includes(h.hackerId),
      );
      return listFiltered;
    },

    totalHackersModeEditing() {
      return this.listAllHackersModeEditing.filter((hacker) => hacker.selected)
        .length;
    },

    listOfHackersForEditing() {
      let filteredList = this.listAllHackersModeEditing;
      if (this.searchHacker) {
        filteredList = filteredList.filter((hacker) =>
          hacker.username
            .toLowerCase()
            .includes(this.searchHacker.toLowerCase()),
        );
        return filteredList;
      }

      const start = (this.pageActive - 1) * this.pageSize;
      let listFiltered = filteredList.slice(start, start + this.pageSize);
      return listFiltered;
    },
  },

  methods: {
    waitAPI: _.debounce(function () {
      this.getListEmail();
    }, 500),

    saveLocalStorage() {
      if (!this.modeEditEmail) {
        this.dataSentEmail = {
          date_sent_email: this.dateSendEmail,
          email_topic: this.topic,
          email_description: this.description,
        };
        localStorage.setItem(
          "dataSentEmail",
          JSON.stringify(this.dataSentEmail),
        );
      }
    },

    openModal() {
      this.loading = true;
      const getItems = JSON.parse(localStorage.getItem("listHackers"));

      setTimeout(() => {
        this.loading = false;
        if (getItems != null) {
          localStorage.setItem("listHackers", JSON.stringify(getItems));
          this.oldListHackers = getItems;
          this.listHackers = getItems;
        }
      }, 3000);

      let storedData = localStorage.getItem("dataSentEmail");
      let data = storedData ? JSON.parse(storedData) : {};

      const {
        date_sent_email = "",
        email_topic = "",
        email_description = "",
      } = data;

      let listProgram =
        JSON.parse(localStorage.getItem("listProgram")) || this.listProgram;

      if (date_sent_email || email_topic || email_description) {
        Swal.fire({
          padding: "0px",
          allowEscapeKey: false,
          heightAuto: false,
          showConfirmButton: false,
          showCancelButton: false,
          html: `<div style="text-align: left; padding:40px 30px;">
                <h2 style="font-size: 24px; font-weigth:400; margin: 0px 0px 10px 0px;">${this.$ml.get(
                  "continueEmail",
                )}</h2>
                <span style="font-size: 16px; margin: 0;">${this.$ml.get(
                  "temporaryEmailStorage",
                )}</span>
                <br>
                <span style="font-size: 16px; margin: 0;">${this.$ml.get(
                  "doYouWantToContinue",
                )}</span>
              </div>
              <div class="d-flex justify-content-end custom-swal-alert" style="width: 100%; background: #f8f9fa; border-top: 1px solid #9e9e9e63; padding: 10px 20px; gap:10px;">
                <button id="confirmButton" class="btn">${this.$ml.get(
                  "continue",
                )}</button>
                <button id="cancelButton" class="btn btn-outline-extra">${this.$ml.get(
                  "clearData",
                )}</button>
              </div>`,
          didOpen: () => {
            document
              .getElementById("confirmButton")
              .addEventListener("click", () => {
                this.dateSendEmail = date_sent_email;
                this.topic = email_topic;
                this.description = email_description;
                this.listProgram = listProgram;
                Swal.close();
              });

            document
              .getElementById("cancelButton")
              .addEventListener("click", () => {
                localStorage.removeItem("dataSentEmail");
                localStorage.removeItem("listProgram");

                setTimeout(() => {
                  localStorage.removeItem("listHackers");
                  this.oldListHackers = [];
                  this.listHackers = [];
                }, 3100);

                Swal.close();
              });
          },
        });
      }
    },

    nextStep() {
      const validatedStepOne =
        this.step === 1 &&
        (!this.topic || !this.description || !this.dateSendEmail);

      if (validatedStepOne) {
        Swal.fire({
          icon: "warning",
          title: this.$ml.get("checkAllFields"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      const validatedStepTwo =
        this.step === 2 &&
        (!this.listProgramSelected.length ||
          (!this.listHackersSelected.length &&
            !this.listOfHackersForEditing.length));

      if (validatedStepTwo) {
        Swal.fire({
          icon: "warning",
          title: this.$ml.get("checkAllFields"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (this.step < 3) {
        this.step++;
      }
    },
    backStep() {
      if (this.step > 1) {
        this.step--;
      }
    },

    closeModal() {
      this.topic = "";
      this.description = "";
      this.dateSendEmail = null;
      this.modeEditEmail = false;
      this.idEmail = "";
      this.emailStatus = "";
      this.listAllHackersModeEditing = [];
      this.pageActive = 1;
      this.step = 1;
      this.showDescription = false;
      this.showPrograms = false;
      this.showHackers = false;
    },

    async getEmailById(id) {
      this.loading = true;

      try {
        this.idEmail = id;
        const { data } = await programService.getEmailById(id);
        this.dateSendEmail = data.dateToSend;
        this.topic = data.topic;
        this.description = data.description;
        this.emailStatus = data.status;

        const filterProgramSelected = this.listProgram.filter(
          (p) => !data.programs.some((program) => program._id === p._id),
        );

        this.listProgram = [
          ...filterProgramSelected,
          ...this.formatObj(data.programs, "hacker"),
        ];

        this.listAllHackersModeEditing = this.formatObj(data.hackers, "hacker");

        setTimeout(() => {
          this.listAllHackersModeEditing.map((h) => {
            if (
              !data.hackers.some((hacker) => hacker.hackerId === h.hackerId)
            ) {
              h.selected = false;
            }

            this.loading = false;
            return h;
          });
        }, 2000);
      } catch (error) {
        console.log(error);
      }
    },

    async getListEmail() {
      this.loadingListEmail = true;
      try {
        const { data } = await programService.getListEmail(
          this.pageActiveEmail,
          this.pageSizeEmail,
          this.searchEmailList,
          this.listFilterSelected.id,
        );
        const { items, total } = data;
        this.listEmail = this.formatObjListEmail(items);
        this.totalPagesEmail = total;
        this.loadingListEmail = false;
      } catch (error) {
        console.log(error);
        this.loadingListEmail = false;
      }
    },

    deleteEmail(id) {
      var self = this;
      Swal.fire({
        heightAuto: false,
        text: self.$ml.get("areYouSureYouWantToDeleteThisEmail"),
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          programService.deleteEmail(id).then(
            () => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("removeEmailSuccess"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.getListEmail();
            },
            (error) => {
              console.log(error);
              Swal.fire({
                icon: "warning",
                title: self.$ml.get("unableToCompleteThisRequest"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            },
          );
        }
      });
    },

    async sendEmail(closeModal) {
      try {
        const filterHackerSelected = this.listHackers.filter(
          (hacker) => hacker.selected,
        );
        const payload = {
          topic: this.topic,
          description: this.description,
          hackers: filterHackerSelected.map((hacker) => hacker.hackerId),
          programs: this.listProgramSelected.map((company) => company._id),
          dateToSend: this.dateSendEmail,
        };
        const { status } = await programService.postCustomEmail(payload);
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendEmailSuccess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.topic = "";
          this.htmlText = "";
          this.description = "";
          this.searchProgram = "";
          this.searchHacker = "";

          localStorage.removeItem("dataSentEmail");
          localStorage.removeItem("listProgram");
          localStorage.removeItem("listAllHackers");
          localStorage.removeItem("listHackers");

          this.getListEmail();
          closeModal();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$ml.get("genericError"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    async updatedEmail(closeModal) {
      try {
        const filterHackerSelected = this.listAllHackersModeEditing.filter(
          (hacker) => hacker.selected,
        );
        const payload = {
          topic: this.topic,
          description: this.description,
          hackers: filterHackerSelected.map((hacker) => hacker.hackerId),
          programs: this.listProgramSelected.map((company) => company._id),
          dateToSend: this.dateSendEmail,
        };
        const { status } = await programService.putCustomEmail(
          payload,
          this.idEmail,
        );
        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendEmailSuccess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.topic = "";
          this.htmlText = "";
          this.description = "";
          this.searchProgram = "";
          this.searchHacker = "";
          this.getListEmail();
          closeModal();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$ml.get("genericError"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    formatObj(obj, type) {
      return obj?.map((item) => ({
        ...item,
        selected:
          item.selected === true ? true : type === "hacker" ? true : false,
      }));
    },

    formatObjListEmail(obj) {
      return obj?.map((item) => ({
        ...item,
        show_message: false,
      }));
    },

    changePrograms(getById) {
      const pageActive = 1;
      const pageSize = 99;
      ProgramService.getProgram(
        "status=in_progress&type=private",
        pageActive,
        pageSize,
      ).then((response) => {
        this.listProgram = this.formatObj(response.data.items, "program");

        if (this.modeEditEmail) {
          this.getEmailById(getById);
        }
      });
    },

    async getHackers() {
      try {
        const filterIds = this.listProgramSelected.map(
          (program) => program._id,
        );
        const payload = {
          programs: filterIds,
        };
        const { data } = await ProgramService.postHackers(payload);

        this.oldListHackers =
          JSON.parse(localStorage.getItem("listHackers")) ?? [];

        this.listHackers = this.modeEditEmail
          ? this.formatObj(data)
          : this.formatObj(data, "hacker");

        if (this.oldListHackers.length && !this.modeEditEmail) {
          const oldIds = new Set(
            this.oldListHackers.map((hacker) => hacker.hackerId),
          );

          this.listHackers = [
            ...this.oldListHackers,
            ...this.listHackers.filter(
              (hacker) => !oldIds.has(hacker.hackerId),
            ),
          ];
        }

        if (this.modeEditEmail) {
          const existingIds = new Set(
            this.listAllHackersModeEditing.map((h) => h.hackerId),
          );
          const newHackers = this.listHackers.map((h) => ({
            ...h,
            selected: existingIds.has(h.hackerId) ? h.selected : true,
          }));

          this.listAllHackersModeEditing = [
            ...this.listAllHackersModeEditing,
            ...newHackers,
          ];

          const seenIds = new Set();
          this.listAllHackersModeEditing =
            this.listAllHackersModeEditing.filter((h) => {
              if (seenIds.has(h.hackerId)) {
                return false;
              }
              seenIds.add(h.hackerId);
              return true;
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.description);
    },
  },
};
</script>
<style scoped>
.c-private-programs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #cccccc63;
  padding: 10px;
  min-height: 42px;
}
div.card-body {
  padding: 0px;
}
div.card-lateral,
.card-hacker {
  height: 100%;
  padding: 0px;
  max-height: 600px;
  overflow: auto;

  scrollbar-width: thin;
  scrollbar-color: #b0b0b08f transparent;
}

div.card-lateral::-webkit-scrollbar {
  width: 6px;
}

div.card-lateral::-webkit-scrollbar-thumb {
  background-color: #b0b0b05e;
  border-radius: 3px;
}

div.card-lateral::-webkit-scrollbar-track {
  background: transparent;
}
.program-title,
.user-title {
  font-weight: 400;
  font-size: 14px;
}
.no-program {
  padding: 10px;
  text-align: center;
  font-weight: 400;
}
.flex-gap {
  gap: 10px;
}
.email-fill {
  position: absolute;
  top: 20%;
  left: 0.7%;
}

.email-status {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 14px;
  font-weight: 400;
  width: 85px;
}
.header-status-email {
  font-weight: 400;
}
.email-status-text {
  font-size: 16px;
}
.badge {
  font-size: 12px;
  padding: 4px 10px;
  min-width: 72px;
}
.less-edit {
  cursor: pointer;
  width: 16px;
  height: 4px;
  background: #730ba9;
  border-radius: 2px;
}
.b-top {
  border-top: 1px solid #cccccc82;
}
.search-input {
  position: absolute;
  top: 50%;
  right: 2%;
}
.setep {
  margin: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.step-option {
  border: 1px solid #730ba9;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.btn-step-action {
  cursor: pointer;
}
.box-details {
  border: 1px solid #cccc;
  border-radius: 6px;
  margin-bottom: 12px;
}
.title-resume {
  font-size: 1.3rem;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  padding: 2px 0px;
}
.box-program {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ccc;
  padding: 5px 0px;
}
.box-header {
  background: #e6e6e659;
}
/* .card-hacker {
  padding: 0px;
  height: 400px;
  overflow: auto;

  scrollbar-width: thin;
  scrollbar-color: #b0b0b08f transparent;
} */
.custom-swal-alert {
  width: 100%;
  background: #f8f9fa;
  border-top: 1px solid #9e9e9e63;
  padding: 20px;
}
</style>
